<template>
  <el-dialog
    :title="uploadCountText"
    :visible.sync="value"
    width="512px"
    :close-on-click-modal="false"
    :before-close="handleClose"
  >
    <div class="upload-url">
      <el-input
        type="textarea"
        :rows="10"
        placeholder="每行一条URL，以回车键隔开，最多100条"
        v-model="textarea"
        @input="textareaChange"
      >
      </el-input>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="handleClose">取 消</el-button>
      <el-button type="primary" @click="onSubmit" :disabled="!textarea"
        >确 定</el-button
      >
    </span>
  </el-dialog>
</template>

<script>
import { materialLibrarysHandler } from "@/assets/js/api";

export default {
  name: "uploadUrl",

  props: {
    value: {
      type: Boolean,
      default: false
    },

    curDirId: {
      type: String,
      default: ""
    }
  },

  computed: {
    uploadCountText() {
      return this.filterArray.length
        ? `上传URL (${this.filterArray.length})条`
        : "上传URL";
    }
  },

  data() {
    return {
      textarea: "",
      filterArray: []
    };
  },

  methods: {
    textareaChange(val) {
      const urlArray = val.split("\n");
      //过滤空数据
      this.filterArray = urlArray.filter(item => {
        return !!item;
      });
    },
    handleClose() {
      this.$emit("input", false);
    },
    onSubmit() {
      //数量限制
      if (this.filterArray.length > 100) {
        this.$message.warning("一次最多上传100个URL");
        return;
      }
      materialLibrarysHandler
        .uploadUrl({
          parentId: +this.curDirId,
          urls: this.filterArray
        })
        .then(res => {
          console.log(res);
          //关闭等待提示
          awaitMsg.close();
          if (res.code !== 200) {
            this.$message.error(res.msg);
            return;
          }
          if (res.data.fail.length === 0) {
            //全部上传成功提示
            this.$notify.success({
              title: "上传成功",
              message: "您的URL已全部上传成功",
              duration: 0
            });
          } else {
            //部分上传失败警告
            this.$notify.info({
              title: "上传完毕",
              message: `您的URL有${res.data.fail.length}条异常，其余上传成功`,
              duration: 0
            });
          }
          //刷新列表数据
          this.$emit("refresh");
          //清空URL输入框
          this.textarea = "";
        })
        .catch(err => {
          awaitMsg.close();
        });
      this.handleClose();
      const awaitMsg = this.$message({
        showClose: true,
        message: "预估时间较长，请耐心等等！",
        type: "warning",
        duration: 0
      });
    }
  },

  created() {}
};
</script>

<style lang="scss"></style>
